<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToButton'
});
</script>
<template>
	<button ref="el" v-dis="loading || disabled" :flex="flex ? flex : null" class="to-button" :class="setClass" :style="setStyle" :desc="desc" @click="handleClick" @dblclick="handleDblClick" @contextmenu="handleContextMenu">
		<ToIcon v-if="icon || loading" class="to-button-icon" :value="props.loading ? 'loading' : icon.split('|')[0].trim()"></ToIcon>
		<span class="to-button-text"> {{ props.text }}<slot></slot> </span>
		<ToIcon v-if="expand" value="expand" class="to-button-expand"></ToIcon>
		<span v-if="Number(progress) > 0" class="to-button-progress">
			<span ref="progress" class="to-button-bar" :class="{ 'is-completed': Number(progress) === 100 }" :style="{ width: progress + '%' }"></span>
		</span>
	</button>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue'
import { commitTouchReport } from '@touchvue/utils'



const el = ref(null)
const emit = defineEmits(['click', 'dblclick', 'contextmenu'])

interface Props {
	disabled?: boolean
	expand?: boolean
	loading?: boolean
	icon?: string
	size?: string
	mode?: string
	color?: string
	width?: string | number
	iconPosition?: string
	progress?: string | number
	desc?: string
	flex?: boolean
	text?: string
}

const props = withDefaults(defineProps<Props>(), {
	mode: 'default',
	color: '',
	size: '',
	icon: '',
	width: '',
	iconPosition: '',
	loading: false,
	disabled: false,
	progress: 0,
	desc: '',
	expand: false,
	flex: false,
	text: ''
})

const setStyle = computed(() => {
	const style: Record<string, string> = {}
	if (props.width && props.width !== 'full') {
		style.width = `${props.width}em`
	}
	return style
})

const setClass = computed(() => {
	let arr: string[] = []
	if (props.width === 'full') {
		arr.push(`width-full`)
	}
	if (props.mode) {
		for (let i = 0; i < props.mode.split(' ').length; i++) {
			const element = props.mode.split(' ')[i]
			arr.push(`mode-${element}`)
		}
	}
	if (props.size) {
		arr.push(`size-${props.size}`)
	}
	if (props.color) {
		arr.push(`color-${props.color}`)
	}
	if (props.iconPosition) {
		arr.push(`icon-position-${props.iconPosition}`)
	}
	if (props.icon.includes('|')) {
		const iconArr = props.icon.split('|')
		if (iconArr[1].includes('top') || iconArr[1].includes('right') || iconArr[1].includes('bottom')) {
			arr.push(`icon-position-${iconArr[1].trim()}`)
		}
	}
	return arr
})

const exportDetail = () => {
	const detail = {
		name: 'ToButton',
		desc: props.desc,
		value: props.desc
	}
	commitTouchReport(detail)
}

const handleClick = evt => {
	emit('click', evt)
	exportDetail()
}

const handleDblClick = evt => {
	emit('dblclick', evt)
	exportDetail()
}

const handleContextMenu = evt => {
	evt.preventDefault()
	emit('contextmenu', evt)
	exportDetail()
}

defineExpose({ el })
</script>
